var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18 5.92a.616.616 0 0 1 0-.87l.87-.87c.24-.24.63-.24.87 0L12 10.26l6.08-6.08c.24-.24.63-.24.87 0l.87.87c.24.24.24.63 0 .87L13.74 12l6.08 6.08c.24.24.24.63 0 .87l-.871.87c-.24.24-.63.24-.87 0L12 13.74l-6.079 6.08c-.24.24-.63.24-.87 0l-.87-.87a.616.616 0 0 1 0-.87L10.26 12 4.18 5.92Z"
  })));
};
export default SvgClose;